import { Turnstile, TurnstileProps } from '@marsidev/react-turnstile';
import LANGUAGE_COOKIE from '~/shared/cookies/LANGUAGE_COOKIE';
import Cookie from '~/shared/utils/Cookie';
import getEnv from '~/shared/utils/getEnv';

type Props = { onSuccess?: TurnstileProps['onSuccess'] };

const CloudFlareTurnstile: FC<Props> = ({ onSuccess }) => {
  const lang = Cookie.get(LANGUAGE_COOKIE);
  const cloudflareTurnstileSiteKey = getEnv('CLOUDFLARE_TURNSTILE_SITE_KEY');
  return (
    <Turnstile
      siteKey={cloudflareTurnstileSiteKey ?? ''}
      onSuccess={onSuccess}
      lang={lang}
      options={{ size: 'flexible', theme: 'light' }}
    />
  );
};

export default CloudFlareTurnstile;
